export default "__VITE_ASSET__DfCOhPFp__"